import { ContentMetadata } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, SpaceBetween } from '@amzn/awsui-components-core';
import { convertEntities } from '@amzn/awscat-editor';
import '../../resources/styles/scss/components/workflow-viewer/workflow-viewer.scss';
import { generatePath } from 'react-router-dom';
import AppContextProps from '../../contexts/AppContextProps';
import { withAppContext } from '../../contexts/AppContext';
import { getContentLocation } from '../../common/ContentPaths';
import RouterPaths from '../../common/RouterPaths';

interface Props extends AppContextProps {
  contentId: string;
  metadata: ContentMetadata;
  navigateBackTo?: string;
  // Force the legacy bar raiser content viewer instead of the UxRedesign /view page.
  // New UI doesn't currently support all actions required by BR
  useLegacyBarRaiserViewer?: boolean;
}

const BarRaiserContentViewerLink = ({
  contentId,
  metadata,
  navigateBackTo,
  useLegacyBarRaiserViewer,
  appContext,
}: Props) => {
  const location = useLegacyBarRaiserViewer
    ? {
        pathname: generatePath(RouterPaths.BAR_RAISER_CONTENT_VIEWER, { contentId }),
        state: { navigateBackTo },
      }
    : getContentLocation({ contentId, mode: 'draft', role: 'bar-raiser' }, { navigateBackTo });
  return (
    <SpaceBetween size="xs" direction="horizontal">
      <Link to={location} className="no-text-decoration">
        {convertEntities(metadata.contentName, appContext.entities)}
      </Link>
    </SpaceBetween>
  );
};

export default withAppContext(BarRaiserContentViewerLink);
